<template>
  <div class="contact-info" :class="darkMode ? 'dark' : ''">
    <UIInput
      :title="$t('First Name')"
      type="text"
      name="first-name"
      id="first-name"
      :darkMode="darkMode"
      v-model="localBookingHost.firstName"
    />
    <UIInput
      :title="$t('Last Name')"
      type="text"
      name="last-name"
      id="last-name"
      v-model="localBookingHost.lastName"
    />
    <UIInput
      :title=" $t('Email')"
      type="email"
      name="email"
      id="email"
      :required="localBooking.notifyHost"
      v-model="localBookingHost.email"
    />
    <UIInput
      :title="$t('Phone')"
      type="tel"
      name="phone"
      id="phone"
      v-model="localBookingHost.phone"
    />
    <UIInput
      class="bookingname"
      :title="$t('Reservation Name')"
      type="text"
      name="booking-name"
      id="booking-name"
      v-model="localBooking.title"
    />
    <UIBirthdatePicker
      class="birthdate"
      :title="$t('Birthdate')"
      :mdy-formatting="$i18n.locale === 'en-US' || $i18n.locale === 'en-us'"
      :value="localBookingHost.birthday"
      @invalid="onBirthdayInvalid"
      @blur="showErrors"
      @change="setHostBirthday"
      :error="!!invalidMessage"
      :errorMsg="invalidMessage"
    />
    <UIInput
      textarea
      class="notes"
      :title="$t('Notes')"
      rows="5"
      v-model="localBooking.notes"
    />
    <UISwitch
      class="notify"
      :title="$t('Send email updates to the customer')"
      :instructions="$t('When on and if an email address is entered, an email will be sent to your customer to detail the following changes to the reservation: date, start time, number of players, experience type, length, group creation or deletion and reservation creation or cancelation.')"
      v-model="localBooking.notifyHost"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIInput from '@/core/shared/components/ui/UIInput';
import UISwitch from '@/core/shared/components/ui/UISwitch';
import UIBirthdatePicker from '@/core/shared/components/ui/UIBirthdatePicker';

@Component({
  components: {
    UISwitch,
    UIInput,
    UIBirthdatePicker,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
})
export default class HostInformation extends Vue {
  invalidBirthday = null;
  invalidReason = null;
  invalidMessage = null;

  get localBooking () {
    return new Proxy(this.booking, {
      set: (object, property, value) => {
        this.$emit('edit:booking', property, value);
        return true;
      },
    });
  }

  get localBookingHost () {
    return new Proxy(this.booking.host, {
      set: (object, property, value) => {
        this.$emit('edit:booking', 'host', { ...this.booking.host, [property]: value });
        return true;
      },
    });
  }

  onBirthdayInvalid ({ reason }) {
    this.invalidBirthday = true;
    this.invalidReason = reason;
  }

  showErrors () {
    if (this.invalidBirthday) {
      this.invalidMessage = this.invalidReason === 'year_digits'
        ? this.$t('Your birthday is invalid. Make sure year is written with four digits.')
        : this.$t('Your birthday is invalid.');
    }
  }

  setHostBirthday (birthday) {
    this.invalidBirthday = false;
    this.invalidMessage = '';
    this.invalidReason = false;
    this.localBookingHost.birthday = birthday;
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.contact-info {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--spacingSm);

  @media (--tablet) {
    grid-template-columns: repeat(2, 1fr);

    & .notes,
    & .notify {
      grid-column: span 2;
    }
  }
}
.contact-info.dark /deep/ .label {
    color: var(--darkModeColorText) !important;
}
</style>
